import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { AED } from "../../lib/api";

export const DisputeDialog = ({ fine, reason, setReason, busy, onSubmit, onClose }) => (
  <Dialog open={!!fine} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="dispute-dialog">
      <DialogHeader>
        <DialogTitle className="heading-upper text-[#144733]">Dispute {fine?.id}</DialogTitle>
      </DialogHeader>
      <p className="text-sm text-[#57685e]">{fine?.type} · {fine && AED(fine.total)}</p>
      <div>
        <label className="field-label">Why are you disputing this fine? *</label>
        <textarea className="field-input" rows={4} value={reason} onChange={(e) => setReason(e.target.value)}
          placeholder="e.g. I was not driving in this area at the recorded time…" data-testid="dispute-reason-input" />
      </div>
      <p className="text-[11px] text-[#8a978f]">Disputes are forwarded to the issuing authority. Deadlines apply per emirate (Dubai: 30 days from notification).</p>
      <button onClick={onSubmit} disabled={busy || !reason.trim()} className="btn-cta rounded w-full py-3 text-xs" data-testid="dispute-submit-btn">
        {busy ? "Submitting…" : "Submit dispute"}
      </button>
    </DialogContent>
  </Dialog>
);
